import type * as CSS from 'csstype';

export type BreakpointsVariantsType =
  | 'default'
  | 'mobile'
  | 'tabletSmall'
  | 'tablet'
  | 'tabletLandscape'
  | 'computer'
  | 'maxWidth';

export type BreakpointsWidthType = '0' | '500px' | '768px' | '900px' | '1024px' | '1220px' | '1440px';

export type BreakpointsAlias = Record<BreakpointsVariantsType, BreakpointsWidthType | CSS.AtRules>;
export type Breakpoints = Partial<BreakpointsAlias> & BreakpointsWidthType[];

const breakpoints: Breakpoints = ['0', '500px', '768px', '900px', '1024px', '1220px', '1440px'];

// theme aliases
/** @returns `0` */
breakpoints.default = breakpoints[0];
/** @returns `500px` */
breakpoints.mobile = breakpoints[1];
/** @returns `768px` */
breakpoints.tabletSmall = breakpoints[2];
/** @returns `900px` */
breakpoints.tablet = breakpoints[3];
/** @returns `1024px` */
breakpoints.tabletLandscape = breakpoints[4];
/** @returns `1220px` */
breakpoints.computer = breakpoints[5];
/** @returns `1440px` */
breakpoints.maxWidth = breakpoints[6];

const breakpointAliases: BreakpointsAlias = {
  default: breakpoints[0],
  mobile: breakpoints[1],
  tabletSmall: breakpoints[2],
  tablet: breakpoints[3],
  tabletLandscape: breakpoints[4],
  computer: breakpoints[5],
  maxWidth: breakpoints[6],
};

export const mqMin = { ...breakpointAliases };
export const mqMax = { ...breakpointAliases };

Object.entries(breakpointAliases).map(breakpoint => {
  const viewport = breakpoint[0] as BreakpointsVariantsType;
  const width = breakpoint[1] as BreakpointsWidthType;
  breakpoints[viewport] = width;

  mqMin[viewport] = `@media only screen and (min-width: ${width})` as CSS.AtRules;
  mqMax[viewport] = `@media only screen and (max-width: ${width})` as CSS.AtRules;
});

export const breakpointsVariants = Object.keys(breakpointAliases) as BreakpointsVariantsType[];

const DEFAULT = breakpoints[0];
const MOBILE = breakpoints[1];
const TABLET_SMALL = breakpoints[2];
const TABLET = breakpoints[3];
const TABLET_LANDSCAPE = breakpoints[4];
const COMPUTER = breakpoints[5];
const MAX_WIDTH = breakpoints[6];

export const BREAKPOINT = {
  /** @returns `0` */
  DEFAULT,
  /** @returns `500px` */
  MOBILE,
  /** @returns `768px` */
  TABLET_SMALL,
  /** @returns `900px` */
  TABLET,
  /** @returns `1024px` */
  TABLET_LANDSCAPE,
  /** @returns `1220px` */
  COMPUTER,
  /** @returns `1440px` */
  MAX_WIDTH,
};

export { breakpoints };
export default breakpoints;
